import { GetCouponListResponse } from '../api-services/get-coupon-list.service';

/**
 * 注文単位値引クーポン一覧画面のタグ情報クラス
 *
 * @export CouponInfo
 * @class CouponInfo
 */
export class CouponInfo {
  public check: boolean = false;
  public couponGoodsNo: string;
  public couponOrderCd: string;
  public couponName: string;
  public couponIssueCatalogStart: string;
  public couponIssueCatalogEnd: string;
  public couponReceiptCatalogStart: string;
  public couponReceiptCatalogEnd: string;
  public couponCategory: string;
  public couponCategoryName: string;
  public noticeExistenceType: string;
  public noticeExistenceTypeName: string;
  public noticeMethodTypeItem: string;
  public noticeMethodTypeNameItem: string;
  public noticeMethodTypeMail: string;
  public noticeMethodTypeNameMail: string;

  constructor(data: GetCouponListResponse['CouponList'][number]) {
    this.couponGoodsNo = data.CouponGoodsNo;
    this.couponOrderCd = data.CouponOrderCd;
    this.couponName = data.CouponName;
    this.couponIssueCatalogStart = data.CouponIssueCatalogStart;
    this.couponIssueCatalogEnd = data.CouponIssueCatalogEnd;
    this.couponReceiptCatalogStart = data.CouponReceiptCatalogStart;
    this.couponReceiptCatalogEnd = data.CouponReceiptCatalogEnd;
    this.couponCategory = data.CouponCategory;
    this.couponCategoryName = data.CouponCategoryName;
    this.noticeExistenceType = data.NoticeExistenceType;
    this.noticeExistenceTypeName = data.NoticeExistenceTypeName;
    this.noticeMethodTypeItem = data.NoticeMethodTypeItem;
    this.noticeMethodTypeNameItem = data.NoticeMethodTypeNameItem;
    this.noticeMethodTypeMail = data.NoticeMethodTypeMail;
    this.noticeMethodTypeNameMail = data.NoticeMethodTypeNameMail;
  }

  get dspCouponCategory() {
    if (!this.couponCategory || !this.couponCategoryName) return '';
    return this.couponCategory + ':' + this.couponCategoryName;
  }
  get dspNoticeExistenceType() {
    if (!this.noticeExistenceType || !this.noticeExistenceTypeName) return '';
    return this.noticeExistenceType + ':' + this.noticeExistenceTypeName;
  }
  get dspNoticeMethodTypeItem() {
    if (!this.noticeMethodTypeItem || !this.noticeMethodTypeNameItem) return '';
    return this.noticeMethodTypeItem + ':' + this.noticeMethodTypeNameItem;
  }
  get dspNoticeMethodTypeMail() {
    if (!this.noticeMethodTypeMail || !this.noticeMethodTypeNameMail) return '';
    return this.noticeMethodTypeMail + ':' + this.noticeMethodTypeNameMail;
  }
}
